export const EPISTEMIC_CYCLE = ['assumption', 'hypothesis', 'fact'];
export const EPISTEMIC_TYPES = new Set(['fact', 'assumption', 'hypothesis']);

/** Shapes that can carry a knowledge-type label (fact / assumption / hypothesis). */
export const EPISTEMIC_LABEL_SHAPE_TYPES = new Set([
  'pin-card',
  'suggest-pin',
  'conversation-pin',
  'text',
  'note',
  'image',
]);

export function normalizeEpistemicType(value) {
  const raw = String(value || '').trim().toLowerCase();
  return EPISTEMIC_TYPES.has(raw) ? raw : null;
}

/** + → assumption → hypothesis → fact → + (cleared). */
export function nextEpistemicType(current) {
  const typed = normalizeEpistemicType(current);
  if (!typed) return 'assumption';
  if (typed === 'fact') return null;
  const index = EPISTEMIC_CYCLE.indexOf(typed);
  return EPISTEMIC_CYCLE[index + 1] || null;
}

export function epistemicLabelForType(type, messages) {
  if (type === 'fact') return messages?.epistemicFact || null;
  if (type === 'hypothesis') return messages?.epistemicHypothesis || null;
  if (type === 'assumption') return messages?.epistemicAssumption || null;
  return null;
}

export function isEpistemicLabelShape(shape) {
  if (!shape || !EPISTEMIC_LABEL_SHAPE_TYPES.has(shape.type)) return false;
  if (shape.type === 'pin-card') return Boolean(shape.meta?.activityId);
  return true;
}

/** User-collected web pins store type on the Activity; other objects use shape.meta. */
export function readShapeEpistemicType(shape, activityById) {
  if (!isEpistemicLabelShape(shape)) return null;
  if (shape.type === 'pin-card') {
    const activityId = shape.meta?.activityId;
    if (!activityId) return null;
    return normalizeEpistemicType(activityById?.(String(activityId))?.epistemicType);
  }
  return normalizeEpistemicType(shape.meta?.epistemicType);
}

export function writeShapeEpistemicType(editor, shape, nextType) {
  if (!editor || !shape) return false;
  const typed = normalizeEpistemicType(nextType);
  const meta = { ...(shape.meta || {}) };
  // updateShape merges meta and skips missing keys, so delete never clears.
  // null overwrites the previous type and reads as unset.
  meta.epistemicType = typed || null;
  editor.markHistoryStoppingPoint?.('epistemic-type');
  editor.updateShape({
    id: shape.id,
    type: shape.type,
    meta,
  });
  return true;
}
